import { HTMLAttributes } from 'react';

import styled from 'styled-components';

import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';
import { Transient } from '@utils/types';

type SeparatorPropsBase = {
  orientation?: 'vertical' | 'horizontal';
} & Pick<React.CSSProperties, 'margin' | 'width' | 'color'>;

export type SeparatorProps = HTMLAttributes<HTMLDivElement> & SeparatorPropsBase;

export const Separator = (props: SeparatorProps) => {
  const { orientation = 'vertical', margin, width, color, ...rest } = props;
  return (
    <StyledSeparator
      className="separator"
      $orientation={orientation}
      $margin={margin}
      $width={width}
      $color={color}
      {...rest}
    />
  );
};

// A 1px vertical divider, 32px tall — sits inline between toolbar/header groups
// and card actions in a row. Explicit height (not maxHeight) so it renders
// regardless of whether the parent row has a definite height.
export const SeparatorInline = () => (
  <Separator orientation="horizontal" style={{ height: pxToRem(32) }} />
);

export const StyledSeparator = styled.div<Transient<SeparatorPropsBase>>(
  ({ $margin, $width = pxToRem(1), $orientation, $color = theme.color.border10 }) => {
    return {
      ...($orientation === 'vertical'
        ? {
            height: $width,
            width: '100%',
            minHeight: $width,
            maxHeight: $width,
          }
        : {
            height: '100%',
            width: $width,
            minWidth: $width,
            maxWidth: $width,
          }),
      backgroundColor: $color,
      margin: $margin,
    };
  }
);
